import {Suspense, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Loader,Splash} from '@src/components';



const ConfigSuspense=({children,configLoaded})=>{
    const [delay,setDelay]=useState(true)

    useEffect(()=>{
        setTimeout(()=>{
            setDelay(false)
        },3000)
    })
        return (
            delay ? <Splash/> : !configLoaded?<Splash/>:<Suspense fallback={<Loader />}>{children}</Suspense>
        )
}

const mapStateToProps=(state)=>{
    return {
        configLoaded:state.config.configLoaded
    }
}


export default connect(mapStateToProps)(ConfigSuspense);